import { LSID_IDENTITY_SET, LSID_IDENTITY_UPDATE, LSID_USERINFO_UPDATE } from "./../constants/action-types";

export function setLsidIdentity(payload) {
    return { type: LSID_IDENTITY_SET, payload };
}

export function updateLsidIdentity(payload) {
    return { type: LSID_IDENTITY_UPDATE, payload };
}

export function updateLsidUserInfo(payload) {
    return { type: LSID_USERINFO_UPDATE, payload };
}
